import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Container
} from "react-bootstrap";
import SearchFilter from "../../../components/SearchFilter";
import Table from "../../../components/Table";
import { getServiceRequest } from "../../../commons/ServiceRequest";
import { useAlert } from "../../../context/AlertContext";
import ButtonOptionSubmenu from "../../../components/ButtonOptionSubmenu";
import AssetService from "../../../services/asset.service";
import CardDisplayComponent from "../../../components/CardDisplayComponent";


export default function ReturnPropertyInstallationWorkOrder() {
  const { showAlert } = useAlert();

  const [loading, setLoading] = useState(false);
  const [assetCodeDD, setassetCodeDD] = useState([]);

  const [searchValue, setSearchValue] = useState([]);
  const [data, setData] = useState([]);

  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row.rowIndex,
      width: "110px"
    },
    {
      name: "รหัสทรัพย์สิน",
      selector: (row) => row.Asset_Code,
      width: "250px"
    },
    {
      name: "ชื่อทรัพย์สิน",
      selector: (row) => row.Asset_Name
    },

    {
      name: "สถานะทรัพย์สิน",
      selector: (row) => row?.informInstallItem?.Asset_Status,
      width: "170px"
    },
    {
      name: "",
      selector: (row) => (
        <ButtonOptionSubmenu
          data={row}
          editButton

        />
      ),
      right: true,
      width: "180px"
    }
  ]

  // const searchInput = [
  //   {
  //     name: "Asset_Code",
  //     label: "รหัสทรัพย์สิน",
  //     queryService: (query) =>
  //       getServiceRequest({
  //         showAlert,
  //         setLoading,
  //         serviceRequest: AssetService.getAssetCode(query),
  //         callback: ({ items }) => setData(items)
  //       })
  //   }
  // ];

  const searchInput = [
    {
      name: "Asset_Code",
      label: "รหัสทรัพย์สิน",
    }
  ];

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: AssetService.getAssetCode(),
      callback: (res) => {
        setassetCodeDD(res)
      }
    });

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: AssetService.getAllAssetReturns(),
      callback: (res) => {
        setData(res.items)
        setSearchValue(res.items)
      }
    });
  }, []);

  const searchData = (search) => {

    let returnData = assetCodeDD.find(item => { return item.Asset_Code == search[0]?.value })
    if (returnData?.Id) {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: AssetService.getAssetReturnsById(returnData.Id),
        callback: (res) => {
          setData([res])
        }
      });
    } else {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: AssetService.getAllAssetReturns(),
        callback: (res) => {
          setData(res.items)
          setSearchValue(res.items)
        }
      });
    }

  };


  const handleSubmit = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);

    dataCallback && console.log(dataCallback);
  };
  return (
    <>
      <Helmet>
        <title>คืนทรัพย์สิน</title>
        <meta
          name="description"
          content="Return Property an Installation Work Order Page"
        />
      </Helmet>

      <Container fluid className="p-0">
        <CardDisplayComponent
          body={{
            element: (
              <SearchFilter
                data={assetCodeDD}
                inputField={searchInput}
                fieldClassName={{ actionButton: "w-auto py-2" }}
                searchCallback={(search) => {
                  searchData(search)
                  // setSearchValue(search)
                }}
              />
            )
          }}
        />

        <CardDisplayComponent
          body={{
            element: (
              <Table
                data={data}
                column={columns}
                pending={loading}
                searchFilter={searchValue}
              />
            )
          }}
        />

        {/* <Card className="m-1 mb-4 p-4 border-0">
          <Card.Body>
            <Row>
              <div className="d-flex justify-content-end">
                <Button
                  type="submit"
                  variant="success"
                  className="me-2 px-5 py-2 text-dark rounded-pill"
                >
                  บันทึกข้อมูล
                </Button>
                <ConfirmModal
                  show={showModal}
                  data={data}
                  content={"save"}
                  onSubmitCallback={handleSubmit}
                />
              </div>
            </Row>
          </Card.Body>
        </Card> */}
      </Container>
    </>
  );
}
